// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"0d7fc330","273":"f5771d07","373":"c647af3b","383":"96fba982","471":"456ef461","574":"d8e19250","583":"a9293cfc","661":"0d1a1ce9","723":"3cbd7ce2","778":"85f6be99","932":"302c1963"}[chunkId] + ".chunk.js";
};